import { types as coreTypes } from '@sitebuilder/core';

export const defaultTypography: coreTypes.Typography = {
    '--heading-level-one': {
        fontFamily: 'OpenSans-Regular',
        fontSize: '32px',
        fontWeight: '700',
        letterSpacing: '',
        wordSpacing: '',
        lineHeight: '40px',
    },
    '--heading-level-two': {
        fontFamily: 'OpenSans-Regular',
        fontSize: '28px',
        fontWeight: '700',
        letterSpacing: '',
        wordSpacing: '',
        lineHeight: '32px',
    },
    '--heading-level-three': {
        fontFamily: 'OpenSans-Regular',
        fontSize: '24px',
        fontWeight: '700',
        letterSpacing: '',
        wordSpacing: '',
        lineHeight: '28px',
    },
    '--heading-level-four': {
        fontFamily: 'OpenSans-Regular',
        fontSize: '20px',
        fontWeight: '700',
        letterSpacing: '',
        wordSpacing: '',
        lineHeight: '28px',
    },
    '--heading-level-five': {
        fontFamily: 'OpenSans-Regular',
        fontSize: '16px',
        fontWeight: '700',
        letterSpacing: '',
        wordSpacing: '',
        lineHeight: '24px',
    },
    '--heading-level-six': {
        fontFamily: 'OpenSans-Regular',
        fontSize: '14px',
        fontWeight: '700',
        letterSpacing: '',
        wordSpacing: '',
        lineHeight: '24px',
    },
    '--section-title': {
        fontFamily: 'OpenSans-Regular',
        fontSize: '16px',
        fontWeight: '500',
        letterSpacing: '',
        wordSpacing: '',
        lineHeight: '28px',
    },
    '--section-sub-title': {
        fontFamily: 'OpenSans-Regular',
        fontSize: '14px',
        fontWeight: '500',
        letterSpacing: '',
        wordSpacing: '',
        lineHeight: '24px',
    },
    '--body-large': {
        fontFamily: 'OpenSans-Regular',
        fontSize: '16px',
        fontWeight: '400',
        letterSpacing: '',
        wordSpacing: '',
        lineHeight: '28px',
    },
    '--body': {
        fontFamily: 'OpenSans-Regular',
        fontSize: '14px',
        fontWeight: '400',
        letterSpacing: '',
        wordSpacing: '',
        lineHeight: '24px',
    },
    '--body-small': {
        fontFamily: 'OpenSans-Regular',
        fontSize: '12px',
        fontWeight: '400',
        letterSpacing: '',
        wordSpacing: '',
        lineHeight: '20px',
    },
};
